import type { AttributesCodeBlock } from '@/elements/code-block/attributes'
import { html } from '@/helpers/html-template'
import { EditorClasses } from '@/styles'
import { guideIconHtml } from '@scalar-org/guide-icons'
import { toVueComponent } from '@scalar-org/vue-render'

export function guideCodeBlockHtml({
  lang,
  isEditable = false,
}: AttributesCodeBlock & { isEditable?: boolean }) {
  const classes = [EditorClasses.Code, 'custom-code', 'custom-scroll'].join(' ')

  const inner = html`<code class="hljs language-${lang}" language="${lang}"><ssg-children /></code>`

  return html`
<div class="${EditorClasses.CodeContainer}" style="position: relative">
  <pre class="${classes}">${isEditable ? '<ssg-children />' : inner}</pre>
  ${!isEditable && languageButtonHtml({ lang })}
</div>
`
}

/** Generates the HTML for the language button in the code block. */
function languageButtonHtml({ lang }: { lang: string }) {
  const classes = ['language-button', EditorClasses.LanguagePicker].join(' ')

  return html`
  <button
    class="${classes}"
    data-scalar-type="code-block-copy"
    type="button">
    <span class="lang-label">${lang}</span>
    <span class="lang-copy">
    ${guideIconHtml({ src: 'solid/interface-copy-clipboard' })}
      Copy
    </span>
    <span class="lang-success">Copied!</span>
  </button>
  `
}

export const ScalarCodeBlockVue = toVueComponent<
  AttributesCodeBlock & { isEditable?: boolean }
>(guideCodeBlockHtml, {
  lang: String,
  isEditable: Boolean,
})
